import { isKeepaliveSupported, isSendBeaconSupported } from '@change-corgi/core/http';

export function getHttpMode(preferredMode: 'fetch' | 'beacon'): 'fetch' | 'beacon' {
	return (preferredMode === 'fetch' && isKeepaliveSupported()) || !isSendBeaconSupported() ? 'fetch' : 'beacon';
}
